export default [{
  path: '/modelos',
  component: {
    resource: 'modelo',
    action: 'read',
    name: 'modelosBase',
    template: '<router-view />',
    meta: {
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'modelos',
    component: () => import('@/app-modulo/documento/modelo/ModeloView.vue'),
    meta: {
      resource: 'modelo',
      action: 'read',
      navActiveLink: 'modelos',
      pageTitle: 'Modelos',
      breadcrumb: [
        {
          text: 'Modelos',
          to: { name: 'modelos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-modelo',
    component: () => import('@/app-modulo/documento/modelo/shared/components/cadastro/Modelo.vue'),
    meta: {
      resource: 'modelo',
      action: 'create',
      navActiveLink: 'modelos',
      pageTitle: 'Modelos',
      breadcrumb: [
        {
          text: 'Modelos',
          to: { name: 'modelos' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-modelo' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-modelo',
    component: () => import('@/app-modulo/documento/modelo/shared/components/cadastro/Modelo.vue'),
    meta: {
      resource: 'modelo',
      action: 'update',
      navActiveLink: 'modelos',
      pageTitle: 'Modelos',
      breadcrumb: [
        {
          text: 'Modelos',
          to: { name: 'modelos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-modelo' },
          active: true,
        },
      ],
    },
  }],
},
]
